export function PlateReader(): JSX.Element {
  return (
    <g>
      <g id="plateReader">
        <rect
          style={{
            fill: '#DEDEDE',
          }}
          y="0"
          width="298.9"
          height="101"
          rx="4.7"
          ry="4.7"
        />
        <g>
          <path
            style={{
              fill: '#e6e6e6',
            }}
            d="M163.5,5.7h123.7c3.1,0,5.6,2.5,5.6,5.6v72.7c0,3.1-2.5,5.6-5.6,5.6h-123.7c-3.1,0-5.6-2.5-5.6-5.6V11.3c0-3.1,2.5-5.6,5.6-5.6h0Z"
          />
          <path
            style={{
              fill: '#4c4b4c',
            }}
            d="M287.2,6.1c2.8,0,5.2,2.3,5.2,5.2v72.7c0,2.8-2.3,5.2-5.2,5.2h-123.7c-2.8,0-5.2-2.3-5.2-5.2V11.3c0-2.8,2.3-5.2,5.2-5.2h123.7M287.2,5.2h-123.7c-3.4,0-6.1,2.7-6.1,6.1v72.7c0,3.4,2.7,6.1,6.1,6.1h123.7c3.4,0,6.1-2.7,6.1-6.1V11.3c0-3.4-2.7-6.1-6.1-6.1h0Z"
          />
        </g>
        <path
          style={{
            fill: '#4a4b4c',
          }}
          d="M278,85.6h-105.3c-2.3,0-4.1-1.8-4.1-4.1V13.7c0-2.2,1.8-4.1,4.1-4.1h105.3c2.3,0,4.1,1.8,4.1,4.1v67.9c0,2.2-1.8,4.1-4.1,4.1Z"
        />
        <g>
          <g>
            <path
              style={{
                fill: '#e6e6e5',
              }}
              d="M4.3,8.4h0c1.6,0,2.2,1.3,2.2,3v72.7c0,1.6-.6,3-2.2,3h0c-1.6,0-2.2-1.3-2.2-3V11.4c0-1.6.6-3,2.2-3h0Z"
            />
            <path
              style={{
                fill: '#4b4b4b',
              }}
              d="M4.3,87.5c-1.7,0-2.7-1.2-2.7-3.4V11.4c0-2.2,1-3.4,2.7-3.4s2.7,1.2,2.7,3.4v72.7c0,2.2-1,3.4-2.7,3.4ZM4.3,8.9c-1.2,0-1.8.8-1.8,2.5v72.7c0,1.7.6,2.5,1.8,2.5s1.8-.8,1.8-2.5V11.4c0-1.7-.6-2.5-1.8-2.5h0Z"
            />
          </g>
          <rect
            style={{
              fill: '#4b4b4b',
            }}
            x="2"
            y="15.8"
            width="4.5"
            height=".9"
          />
          <rect
            style={{
              fill: '#4b4b4b',
            }}
            x="2"
            y="78.9"
            width="4.5"
            height=".9"
          />
        </g>
        <g>
          <g>
            <rect
              style={{
                fill: '#e6e6e6',
              }}
              x="8.9"
              y="3.5"
              width="143.3"
              height="88.6"
              rx="6.2"
              ry="6.2"
            />
            <path
              style={{
                fill: '#4d4b4d',
              }}
              d="M146,3.9c3.2,0,5.8,2.6,5.8,5.8v76.1c0,3.2-2.6,5.8-5.8,5.8H15.1c-3.2,0-5.8-2.6-5.8-5.8V9.7c0-3.2,2.6-5.8,5.8-5.8h130.9M146,3H15.1c-3.7,0-6.7,3-6.7,6.7v76.1c0,3.7,3,6.7,6.7,6.7h130.9c3.7,0,6.7-3,6.7-6.7V9.7c0-3.7-3-6.7-6.7-6.7h0Z"
            />
          </g>
          <path
            style={{
              fill: '#4d4b4d',
            }}
            d="M144.7,6.6c2.3,0,4.2,1.9,4.2,4.2v74c0,2.3-1.9,4.2-4.2,4.2H16.3c-2.3,0-4.2-1.9-4.2-4.2V10.8c0-2.3,1.9-4.2,4.2-4.2h128.5M144.7,5.7H16.3c-2.8,0-5.1,2.3-5.1,5.1v74c0,2.8,2.3,5.1,5.1,5.1h128.5c2.8,0,5.1-2.3,5.1-5.1V10.8c0-2.8-2.3-5.1-5.1-5.1h0Z"
          />
          <rect
            style={{
              fill: '#4b4b4b',
            }}
            x="142.1"
            y="29.3"
            width="3.3"
            height="10.3"
            rx="1.7"
            ry="1.7"
          />
          <circle
            style={{
              fill: '#fff',
            }}
            cx="143.7"
            cy="31.1"
            r=".8"
          />
          <circle
            style={{
              fill: '#fff',
            }}
            cx="143.7"
            cy="33.4"
            r=".8"
          />
          <circle
            style={{
              fill: '#fff',
            }}
            cx="143.7"
            cy="35.6"
            r=".8"
          />
          <circle
            style={{
              fill: '#fff',
            }}
            cx="143.7"
            cy="37.9"
            r=".8"
          />
          <rect
            style={{
              fill: '#4b4b4b',
            }}
            x="142.1"
            y="53.8"
            width="3.3"
            height="10.3"
            rx="1.7"
            ry="1.7"
          />
          <circle
            style={{
              fill: '#fff',
            }}
            cx="143.7"
            cy="55.6"
            r=".8"
          />
          <circle
            style={{
              fill: '#fff',
            }}
            cx="143.7"
            cy="57.9"
            r=".8"
          />
          <circle
            style={{
              fill: '#fff',
            }}
            cx="143.7"
            cy="60.1"
            r=".8"
          />
          <circle
            style={{
              fill: '#fff',
            }}
            cx="143.7"
            cy="62.4"
            r=".8"
          />
          <path
            style={{
              fill: '#4b4b4b',
            }}
            d="M22.9,89.3h-.7v-2.2h-5.1c-1.2,0-2.1-.3-2.6-.9-.6-.7-.6-1.5-.5-1.6V11.3c0-1,.3-1.8.9-2.3.8-.7,1.8-.6,2-.6h5.6v-2.2h.7v2.9h-6.4s-.9-.1-1.5.4c-.4.4-.6.9-.6,1.7v73.3s0,.6.4,1.1c.4.4,1.1.7,2.1.7h5.8v2.9h0Z"
          />
          <path
            style={{
              fill: '#4b4b4b',
            }}
            d="M123.2,89.3h-.7v-2.9h6.4s.9.1,1.5-.4c.4-.4.6-.9.6-1.7V11s0-.6-.4-1.1c-.4-.4-1.1-.7-2.1-.7h-5.8v-2.9h.7v2.2h5.1c1.2,0,2.1.3,2.6.9.6.7.6,1.5.5,1.6v73.2c0,1-.3,1.8-.9,2.3-.8.7-1.8.6-2,.6h-5.6v2.2h0Z"
          />
        </g>
        <rect
          style={{
            fill: '#fff',
          }}
          x="27.2"
          y="17.6"
          width="92.5"
          height="60.4"
          rx="2.5"
          ry="2.5"
        />
      </g>
    </g>
  )
}
